(function () {
  function toHandle(str) {
    return String(str || '')
      .trim()
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function getAvailableColorHandlesFromImages() {
    const gallery = document.querySelector('media-gallery');
    if (!gallery) return new Set();

    const imgs = gallery.querySelectorAll('li.product__media-item img');
    const handles = new Set();

    imgs.forEach((img) => {
      const alt = (img.getAttribute('alt') || '').toLowerCase();
      const m = alt.match(/c:([a-z0-9-]+)/);
      if (m && m[1]) handles.add(m[1]);
    });

    return handles;
  }

  function getSelectedColorHandle(handlesSet) {
    if (!handlesSet || handlesSet.size === 0) return null;

    // 1) Intento: cualquier radio checked cuyo value mapee a un handle válido
    const checkedRadios = document.querySelectorAll('input[type="radio"]:checked');
    for (const r of checkedRadios) {
      const h = toHandle(r.value);
      if (handlesSet.has(h)) return h;
    }

    // 2) Intento: texto visible "Color: X"
    // Buscamos nodos "simples" (sin hijos) para evitar falsos positivos
    const candidates = document.querySelectorAll('p, span, div, label');
    for (const el of candidates) {
      if (el.children && el.children.length) continue;
      const txt = (el.textContent || '').trim();
      if (!txt) continue;

      // "Color: Rich Maroon" / "Color : Rich Maroon"
      const lower = txt.toLowerCase();
      if (lower.startsWith('color:') || lower.startsWith('color :')) {
        const parts = txt.split(':');
        const value = (parts[1] || '').trim();
        const h = toHandle(value);
        if (handlesSet.has(h)) return h;
      }
    }

    return null;
  }

  function applyFilterByAlt(colorHandle) {
    const gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    const slides = gallery.querySelectorAll('li.product__media-item');
    if (!slides.length) return;

    slides.forEach((slide) => {
      const alt = (slide.querySelector('img')?.getAttribute('alt') || '').toLowerCase();
      const m = alt.match(/c:([a-z0-9-]+)/);
      const tag = m && m[1] ? m[1] : null;

      // Si no tiene tag c:..., lo dejamos visible (neutro)
      const show = !tag ? true : tag === colorHandle;

      slide.hidden = !show;
      slide.setAttribute('aria-hidden', show ? 'false' : 'true');
      slide.style.display = show ? '' : 'none';
    });
  }

  function init() {
    let last = null;

    const handlesSet = getAvailableColorHandlesFromImages();

    const run = () => {
      const current = getSelectedColorHandle(handlesSet);
      if (!current) return;

      if (current !== last) {
        last = current;
        applyFilterByAlt(current);
      }
    };

    // inicial + reintentos cortos
    run();
    let tries = 0;
    const t = setInterval(() => {
      run();
      tries += 1;
      if (tries > 20) clearInterval(t); // ~3s
    }, 150);

    // listeners
    document.addEventListener('change', () => setTimeout(run, 50));
    document.addEventListener('click', () => setTimeout(run, 50));
  }

  document.addEventListener('DOMContentLoaded', init);
})();
